import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { connectWithSocketIOServer, socket } from "../src/client/wss";
import "./App.css";
import { getSessionId } from "./client/sessionSetup";
import Home from "./Home/Home";

function App() {
  const id = document.getElementById("chatBot").getAttribute("data-value");
  // const id = "66c5e0b44e27d91343aa4cf3";
  // const id = "673c37ff71fc1e546015c46c";
  // const id = "66c5e0b44e27d91343aa4cf3"; //shopif stg
  // const id = "66379b5267df461925f72763";
  // const id="67da58d7930a1088220f257f" //big com stg
  // const id="67d108e8e85da8169e91431d"  //big com prod

  useEffect(async () => {
    if (!localStorage.getItem("sessionUUID")) {
      localStorage.setItem("sessionUUID", uuidv4().toString());
    }
    getSessionId(localStorage.getItem("sessionUUID"));
    connectWithSocketIOServer();
    return () => {
      socket.off("connect");
    };
  }, []);

  return (
    <Box className="App">
      <Home botid={id} />
    </Box>
  );
}

export default App;
